import type { FaireProductEntity } from "../../entity_types/product";

export const p_495zgeetkv: FaireProductEntity = {
  token: "p_495zgeetkv",
  type: "product",
  name: "18K Gold Plated Stainless Steel Wavy Zircon Ring – US 7",
  brandToken: "b_wxdny9yjk7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/81dfc37e56783601355347327a59939141dcf6e994cdb7725dc4389660752974.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c43f15e1703a0fcd85e6fca6a1b1a43c68426a13d2ddd746135e487397bf3c9.jpeg",
    "https://cdn.faire.com/fastly/931429a43c11619644ebaff74e8262d30ec6ca093e5a504112372946e0b0b259.jpeg",
    "https://cdn.faire.com/fastly/7f1ecb6c5740130637b2ea9b1e0a1bdda3ed8708a6c59924a7105840ef1a9ae8.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "This modern wavy band ring blends sculptural design with refined elegance. Its fluid gold-plated stainless steel band is set with a sparkling zircon stone, creating a unique statement piece that’s both versatile and eye-catching.\n\nMade with waterproof, hypoallergenic stainless steel, the ring is durable, tarnish-resistant, and comfortable for daily wear. Perfect for boutiques seeking trendy, fashion-forward jewelry with strong gift appeal.\n\n18K gold-plated stainless steel, waterproof and hypoallergenic\nSculptural wavy design with zircon accent\nTarnish-resistant and lightweight for everyday wear\nA standout wholesale accessory with boutique-ready styling\n\nMaterial\n18K Gold Plated Stainless Steel\nZircon Stone\n\nDimensions\nRing Size: US 7\nWidth: 0.68 in (1.73 cm) * 0.50 in (1.27 cm)\nWeight: 0.08 oz (2.4 g)",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:23.357Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
